<template>
  <v-main>
    <v-container fluid>
      <!-- 🔍 Search Section -->
      <v-row>
        <v-col cols="12">
          <v-card elevation="3" rounded="xxl">
            <v-card-title>
              <v-btn
                class="mx-2"
                fab
                x-small
                color="primary"
                @click="$router.back()"
              >
                <v-icon dark> mdi-arrow-left </v-icon>
              </v-btn>
              <h3 class="font-weight-bold">User VIP Subscriptions</h3>
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col md="6">
                  <v-text-field
                    solo
                    rounded
                    v-model="filter.search_keyword"
                    label="Search..."
                    clearable
                    prepend-inner-icon="mdi-magnify"
                    @keydown.enter="getData"
                    @click:clear="resetFilter"
                  />
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <!-- 📋 Table Section -->
      <v-row>
        <v-col cols="12">
          <v-card elevation="3" rounded="xxl">
            <v-card-text>
              <v-simple-table fixed-header height="285px">
                <thead>
                  <tr>
                    <th class="text-left">Sr No</th>
                    <th class="text-left">Status</th>
                    <th class="text-left">User</th>
                    <th class="text-left">VIP Tier</th>
                    <th class="text-left">Source</th>
                  </tr>
                </thead>

                <!-- 🟢 Table Data -->
                <tbody v-if="subscriptions.length">
                  <tr
                    v-for="(item, i) in subscriptions"
                    :key="`item_${i}`"
                    :class="{
                      'table-row-even': i % 2 === 0,
                      'table-row-odd': i % 2 !== 0,
                      'table-row-last': subscriptions.length - 1 == i,
                    }"
                  >
                    <td style="min-width: 85px">{{ i + 1 }}</td>

                    <!-- ✅ Status -->
                    <td>
                      <v-chip
                        small
                        :color="item.is_active ? 'teal' : 'red'"
                        text-color="white"
                      >
                        <v-avatar left>
                          <v-icon size="16">
                            {{
                              item.is_active
                                ? "mdi-checkbox-marked-circle"
                                : "mdi-close-circle"
                            }}
                          </v-icon>
                        </v-avatar>
                        {{ item.is_active ? "Active" : "Inactive" }}
                      </v-chip>
                    </td>

                    <!-- 👤 User -->
                    <td>{{ item.user?.first_name || "-" }}</td>

                    <!-- 👑 VIP Tier -->
                    <td>
                      <v-chip small color="primary" text-color="white">
                        <v-avatar left>
                          <v-icon size="16">mdi-crown</v-icon>
                        </v-avatar>
                        Level {{ item.vip_level?.level || "0" }}
                      </v-chip>
                    </td>

                    <!-- 📌 Source -->
                    <td>
                      <v-chip
                        size="26"
                        :color="item.source == 0 ? 'blue' : 'purple'"
                        text-color="white"
                      >
                        {{ item.source == 0 ? "Purchase" : "Achievement" }}
                      </v-chip>
                    </td>
                  </tr>
                </tbody>

                <!-- 🚫 No Data -->
                <tbody v-else>
                  <tr>
                    <td colspan="7" class="text-center">No data found</td>
                  </tr>
                </tbody>
              </v-simple-table>

              <!-- 📄 Pagination -->
              <v-pagination
                v-model="page"
                :length="paginationLength"
                class="mt-2"
                total-visible="7"
              />
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";

export default {
  name: "UserVipSubscriptionsPage",
  data() {
    return {
      filter: { search_keyword: "" },
      subscriptions: [],
      page: 1,
      paginationLength: 0,
      count: 0,
    };
  },
  mounted() {
    this.getData();
  },
  watch: {
    page() {
      this.getData();
    },
  },
  methods: {
    async getData() {
      try {
        const query = `page=${this.page}&rowsPerPage=${this.rowsPerPage}&search_keyword=${this.filter.search_keyword}`;
        const { data } = await axios.get(`/user_vip_subscriptions?${query}`);
        this.subscriptions = data.data;
        this.count = data.count;
        this.paginationLength = Math.ceil(this.count / this.rowsPerPage);
      } catch (error) {
        console.error("Error fetching subscriptions:", error);
      }
    },
    resetFilter() {
      this.filter.search_keyword = "";
      this.page = 1;
      this.getData();
    },
    async Delete_this(id) {
      if (!confirm("Are you sure you want to delete this entry?")) return;
      try {
        await axios.post(
          `/user_vip_subscriptions/delete/${this.encryptIt(id)}`
        );
        this.getData();
      } catch (error) {
        console.error("Error deleting subscription:", error);
      }
    },
    encryptIt(id) {
      return btoa(id); // simple base64 encode
    },
  },
};
</script>
